module.exports = __webpack_public_path__ + "web_static/img/monnery_map.791cec52.jpg";